// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_0Rf","cls2":"LoggedOutDiscoveryPage-cls2_y90 LoggedOutDiscoveryPage-cls1_0Rf"};